import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const LockerIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" className={className} onClick={onClick}>
      <path fill="#414141" d="M12.8 3.2a.64.64 0 01-.64.64h-1.92a.64.64 0 010-1.28h1.92a.64.64 0 01.64.64zm-.64 1.92h-1.92a.64.64 0 000 1.28h1.92a.64.64 0 000-1.28zM3.2 3.84h1.92a.64.64 0 000-1.28H3.2a.64.64 0 000 1.28zm1.92 1.28H3.2a.64.64 0 000 1.28h1.92a.64.64 0 000-1.28zm10.24-3.84v14.08a.64.64 0 11-1.28 0v-1.28H8.32v1.28a.64.64 0 01-1.28 0v-1.28H1.28v1.28a.64.64 0 01-1.28 0V1.28A1.28 1.28 0 011.28 0h12.8a1.28 1.28 0 011.28 1.28zM7.04 12.8V1.28H1.28V12.8h5.76zm1.28 0h5.76V1.28H8.32V12.8z" ></path>
    </svg>
  );
};

export default LockerIcon;
